import { render, staticRenderFns } from "./ProductBoostLegend.vue?vue&type=template&id=57c95aa1&scoped=true&"
import script from "./ProductBoostLegend.vue?vue&type=script&lang=js&"
export * from "./ProductBoostLegend.vue?vue&type=script&lang=js&"
import style0 from "./ProductBoostLegend.vue?vue&type=style&index=0&id=57c95aa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c95aa1",
  null
  
)

/* custom blocks */
import block0 from "./ProductBoostLegend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
